import { Component, computed, ElementRef, ViewChild } from '@angular/core';
import { AppMenu } from './app.menu';
import { LayoutService } from '@core/diamond/service/layout.service';
import { RouterModule } from '@angular/router';
import { AppTopbar } from '@core/diamond/components/app.topbar';
import { CommonModule } from '@angular/common';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [CommonModule, AppMenu, RouterModule, AppTopbar],
  template: `<div
    class="layout-sidebar"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <div class="sidebar-header">
      <a class="logo items-center" [routerLink]="['/']">
        <img
          class="logo-image !max-w-12"
          [src]="
            menuTheme() === 'light'
              ? '/layout/images/isotype-dark.svg'
              : '/layout/images/isotype-dark.svg'
          "
          alt="bitcloud-logo"
        />
        <div class="app-name flex flex-col text-left leading-tight tracking-tight">
          <span class="text-2xl font-semibold leading-none">Bit Cloud</span>
          <span class="text-base opacity-70 leading-none">Nómina</span>
        </div>
      </a>
      <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
    </div>

    <div #menuContainer class="layout-menu-container">
      <div app-menu></div>
    </div>
    <div app-topbar *ngIf="isHorizontal()"></div>
  </div>`,
})
export class AppSidebar {
  timeout: any = null;

  isHorizontal = computed(() => this.layoutService.isHorizontal());

  menuTheme = computed(() => this.layoutService.layoutConfig().menuTheme);

  @ViewChild('menuContainer') menuContainer!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public el: ElementRef,
  ) {}

  onMouseEnter() {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true,
          };
        }
        return state;
      });
    }
  }

  onMouseLeave() {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false,
              };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  anchor() {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored,
    }));
  }
}
